/* WowStore KYC Gate (BytePlus-committed: AI video + real-portrait require
   login + completed purchase + content-consent "I hold the rights").
   Global, dependency-free. Two jobs:
   (1) inject browser_id + logged-in email into the gated generation calls so
       the server (/tryon/video/generate, /tryon/upload-photo) resolves the
       member's KYC tier;
   (2) when the server returns 403 {error:"kyc_required"} (enforce mode), show
       the login -> purchase -> consent flow instead of a dead error.
   In shadow mode no 403 fires, so this just flows identity through (harmless). */
(function () {
  'use strict';
  if (window.__WOWS_KYC_GATE__) { return; }
  window.__WOWS_KYC_GATE__ = true;

  var API = 'https://ai-api.wowstore.live/api/wows';
  var LOGIN_URL = '/account/login';
  var BUY_URL = '/pages/store-credits';

  function getEmail() { try { return window.__WOWS_EMAIL || null; } catch (e) { return null; } }
  function getBrowserId() {
    var id;
    try { id = localStorage.getItem('lucy_browser_id'); } catch (e) { id = null; }
    if (!id) {
      id = 'b' + Date.now() + Math.random().toString(36).slice(2, 8);
      try { localStorage.setItem('lucy_browser_id', id); } catch (e) {}
    }
    return id;
  }

  // Surfaces gated per the signed BytePlus KYC (video + real-person portrait).
  var GATED = [/\/tryon\/video\/generate\b/, /\/tryon\/upload-photo\b/];
  function isGated(url) {
    try { return GATED.some(function (re) { return re.test(String(url)); }); } catch (e) { return false; }
  }

  // ---- fetch wrapper: inject identity + catch kyc_required ----
  var _fetch = window.fetch ? window.fetch.bind(window) : null;
  if (_fetch) {
    window.fetch = function (input, init) {
      var url = (typeof input === 'string') ? input : (input && input.url) || '';
      if (!isGated(url)) { return _fetch(input, init); }
      try {
        init = init || {};
        var email = getEmail(), bid = getBrowserId();
        if (typeof init.body === 'string') {
          try {
            var o = JSON.parse(init.body);
            if (!o.browser_id) { o.browser_id = bid; }
            if (email && !o.email) { o.email = email; }
            init.body = JSON.stringify(o);
          } catch (e) { /* not JSON — leave as-is */ }
        } else if (init.body && typeof FormData !== 'undefined' && init.body instanceof FormData) {
          if (!init.body.has('browser_id')) { init.body.append('browser_id', bid); }
          if (email && !init.body.has('email')) { init.body.append('email', email); }
        }
      } catch (e) { /* never break the call */ }
      return _fetch(input, init).then(function (res) {
        if (res && res.status === 403) {
          try {
            return res.clone().json().then(function (j) {
              if (j && j.error === 'kyc_required') { showGate(j.feature || 'video', j.kyc || {}); }
              return res;
            }).catch(function () { return res; });
          } catch (e) { return res; }
        }
        return res;
      });
    };
  }

  // ---- public API for surfaces that want to gate proactively (button click) ----
  // WowsKYC.ensure('video') -> Promise<boolean> (true if verified; else shows gate, resolves false)
  window.WowsKYC = {
    ensure: function (feature) {
      var q = 'browser_id=' + encodeURIComponent(getBrowserId());
      var e = getEmail(); if (e) { q += '&email=' + encodeURIComponent(e); }
      return fetch(API + '/kyc-status?' + q).then(function (r) { return r.json(); }).then(function (s) {
        if (s && s.kyc_verified) { return true; }
        showGate(feature || 'video', s || {});
        return false;
      }).catch(function () { return true; }); // fail open — never block on a status error
    },
    status: function () {
      var q = 'browser_id=' + encodeURIComponent(getBrowserId());
      var e = getEmail(); if (e) { q += '&email=' + encodeURIComponent(e); }
      return fetch(API + '/kyc-status?' + q).then(function (r) { return r.json(); });
    }
  };

  // ---- gate modal ----
  function injectStyles() {
    if (document.getElementById('wows-kyc-styles')) { return; }
    var s = document.createElement('style');
    s.id = 'wows-kyc-styles';
    s.textContent = [
      '.wkyc-ov{position:fixed;inset:0;background:rgba(17,24,39,.62);backdrop-filter:blur(3px);z-index:2147483600;display:flex;align-items:center;justify-content:center;padding:20px;}',
      '.wkyc-card{background:#fff;border-radius:20px;max-width:440px;width:100%;padding:28px;box-shadow:0 20px 60px rgba(0,0,0,.3);font-family:inherit;color:#111827;position:relative;}',
      '.wkyc-x{position:absolute;top:14px;right:16px;border:none;background:none;font-size:22px;line-height:1;cursor:pointer;color:#9CA3AF;}',
      '.wkyc-badge{display:inline-block;font-size:12px;font-weight:700;letter-spacing:.5px;text-transform:uppercase;color:#8B5CF6;margin-bottom:8px;}',
      '.wkyc-h{font-size:22px;font-weight:800;margin:0 0 8px;}',
      '.wkyc-p{font-size:14px;color:#6B7280;line-height:1.5;margin:0 0 18px;}',
      '.wkyc-btn{display:block;width:100%;padding:13px;border:none;border-radius:12px;background:linear-gradient(135deg,#DB2777,#8B5CF6);color:#fff;font-weight:700;font-size:15px;cursor:pointer;text-align:center;text-decoration:none;box-sizing:border-box;}',
      '.wkyc-btn[disabled]{opacity:.5;cursor:default;}',
      '.wkyc-ck{display:flex;gap:10px;align-items:flex-start;font-size:13px;color:#374151;margin:0 0 12px;line-height:1.45;cursor:pointer;}',
      '.wkyc-ck input{margin-top:2px;flex-shrink:0;width:16px;height:16px;}',
      '.wkyc-note{font-size:12px;color:#9CA3AF;margin-top:14px;text-align:center;}'
    ].join('');
    document.head.appendChild(s);
  }

  function close() {
    var ov = document.getElementById('wows-kyc-ov');
    if (ov && ov.parentNode) { ov.parentNode.removeChild(ov); }
  }

  function shell(inner) {
    injectStyles();
    close();
    var ov = document.createElement('div');
    ov.className = 'wkyc-ov'; ov.id = 'wows-kyc-ov';
    ov.addEventListener('click', function (e) { if (e.target === ov) { close(); } });
    var card = document.createElement('div');
    card.className = 'wkyc-card';
    var x = document.createElement('button');
    x.className = 'wkyc-x'; x.type = 'button'; x.textContent = '×';
    x.addEventListener('click', close);
    card.appendChild(x);
    inner(card);
    ov.appendChild(card);
    document.body.appendChild(ov);
  }

  function featureLabel(feature) {
    return feature === 'portrait' ? 'upload your own photo' : 'create AI video';
  }

  function showGate(feature, kyc) {
    kyc = kyc || {};
    var label = featureLabel(feature);
    if (!kyc.logged_in) {
      shell(function (card) {
        addHead(card, 'Members only', 'Log in to ' + label, 'Create a free WowStore account (or log in) to use AI Studio, your Virtual Closet and Avatar — your designs and rewards live in your profile.');
        addLink(card, 'Log in / Sign up', LOGIN_URL);
        addNote(card, 'Free to join. It takes a few seconds.');
      });
      return;
    }
    if (!kyc.has_purchase) {
      shell(function (card) {
        addHead(card, 'Unlock creation', 'One step to ' + label, 'AI video and the Magic Mirror with your own photo are unlocked with your first purchase — this verifies your account so we can keep the AI safe and on the right side of the rules. Top up Wows or grab anything from the store.');
        addLink(card, 'Top up / Shop to unlock', BUY_URL);
        addNote(card, 'Your purchase verifies your identity (BytePlus AI safety requirement).');
      });
      return;
    }
    if (!kyc.consent_accepted) {
      shell(function (card) {
        addHead(card, 'One-time consent', 'Confirm before you ' + label, 'Because AI can render people, we need your OK once:');
        var c1 = addCheck(card, 'I confirm I hold the rights to any photo I upload (it’s me, or I have permission).');
        var c2 = addCheck(card, 'I accept the WowStore AI Content Rules (no deepfakes, no other people without consent).');
        var btn = document.createElement('button');
        btn.className = 'wkyc-btn'; btn.type = 'button'; btn.textContent = 'Confirm & continue';
        btn.addEventListener('click', function () {
          if (!(c1.checked && c2.checked)) {
            btn.textContent = 'Please tick both boxes';
            setTimeout(function () { btn.textContent = 'Confirm & continue'; }, 1600);
            return;
          }
          btn.disabled = true; btn.textContent = 'Saving…';
          var body = { browser_id: getBrowserId(), hold_rights: true, accept_rules: true };
          var e = getEmail(); if (e) { body.email = e; }
          fetch(API + '/accept-consent', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
            .then(function (r) { return r.json(); })
            .then(function (res) {
              if (res && res.ok) { showDone(label); }
              else { btn.disabled = false; btn.textContent = 'Try again'; }
            })
            .catch(function () { btn.disabled = false; btn.textContent = 'Try again'; });
        });
        card.appendChild(btn);
        addNote(card, 'We store this once on your account. Governed by our AI Content Policy v1.0.');
      });
      return;
    }
    showDone(label);
  }

  function showDone(label) {
    shell(function (card) {
      addHead(card, 'You’re verified', 'All set — you can ' + label, 'Your account is verified and consent is on file. Tap the create button again to start.');
      var b = document.createElement('button');
      b.className = 'wkyc-btn'; b.type = 'button'; b.textContent = 'Got it';
      b.addEventListener('click', close);
      card.appendChild(b);
    });
  }

  function addHead(card, badge, h, p) {
    var b = document.createElement('div'); b.className = 'wkyc-badge'; b.textContent = badge; card.appendChild(b);
    var hh = document.createElement('h3'); hh.className = 'wkyc-h'; hh.textContent = h; card.appendChild(hh);
    var pp = document.createElement('p'); pp.className = 'wkyc-p'; pp.textContent = p; card.appendChild(pp);
  }
  function addLink(card, text, href) {
    var a = document.createElement('a'); a.className = 'wkyc-btn'; a.href = href; a.textContent = text; card.appendChild(a);
  }
  function addCheck(card, text) {
    var lab = document.createElement('label'); lab.className = 'wkyc-ck';
    var inp = document.createElement('input'); inp.type = 'checkbox';
    var sp = document.createElement('span'); sp.textContent = text;
    lab.appendChild(inp); lab.appendChild(sp); card.appendChild(lab);
    return inp;
  }
  function addNote(card, text) {
    var n = document.createElement('div'); n.className = 'wkyc-note'; n.textContent = text; card.appendChild(n);
  }
})();
